import {
  PushpinFilled,
  PushpinOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import { useContext, useEffect, useLayoutEffect, useState } from "react";
import DatastoreCategory from "components/Organisms/DatastoresMenu/DatastoreCategory";

import { useDatastoresTypeEffect } from "hooks/datastores/useDatastoresTypeEffect";
import { useDatastoreTypes } from "hooks/datastores/useDatastoreTypes";

import { MenuContext } from "contexts/menu";
import { StyledWrapper, StyledPinned } from "./styles";
import { Tabs } from "antd";
import type { TabsProps } from "antd";
import { useAuth } from "hooks/user/useAuth/useAuth";

import DomainsMenu from "./DomainsMenu/DomainsMenu";
import { useDatastoreStore } from "hooks/datastores/useDatastoresStore";
import { useDomains } from "hooks/domains/useDomains";

interface DatastoresMenuProps {
  // eslint-disable-next-line no-unused-vars
  setSize: (value: (number | undefined)[]) => void;
}

const DatastoresMenu = ({ setSize }: DatastoresMenuProps) => {
  const {
    isDatastoresMenuActive,
    setIsDatastoresMenuActive,
    isDatastoresMenuPinned,
    setIsDatastoresMenuPinned,
  } = useContext(MenuContext);
  const loadDatastoresData = useDatastoreStore((s) => s.loadDatastoresTypes);

  const [tab, setTab] = useState("Domains");

  const togglePin = () => {
    setIsDatastoresMenuPinned &&
      setIsDatastoresMenuPinned(!isDatastoresMenuPinned);
  };
  const { domainsInfo } = useDomains();

  const items: TabsProps["items"] =
    domainsInfo?.data && domainsInfo?.data?.length > 0
      ? [
          {
            key: "Domains",
            label: "Domains",
            children: undefined,
          },
          {
            key: "Datastores",
            label: "Datastores",
            children: undefined,
          },
        ]
      : [];

  const onChange = (key: string) => {
    setTab(key);
  };
  const onEnter = () =>
    setIsDatastoresMenuActive && setIsDatastoresMenuActive(true);

  const onLeave = () => {
    if (isDatastoresMenuPinned) return;
    setIsDatastoresMenuActive && setIsDatastoresMenuActive(false);
  };
  const { isLogged } = useAuth();

  // To set min and max sizes depending on the states
  useLayoutEffect(() => {
    if (isDatastoresMenuActive || isDatastoresMenuPinned) {
      return setSize([200, 1000]);
    }

    setSize([60, 60]);
  }, [isDatastoresMenuActive, isDatastoresMenuPinned, setSize]);

  const datastore_types = useDatastoreTypes();
  useDatastoresTypeEffect("#datastore-types", datastore_types);
  useEffect(() => {
    if (isLogged) {
      loadDatastoresData();
    }
  }, []);
  if (!isLogged) return null;
  return (
    <div className="pr-1 pt-2 pb-3 h-full prevent-color-propagation">
      <StyledWrapper
        className="datastore-menu"
        data-pinned={isDatastoresMenuPinned}
        onMouseEnter={onEnter}
        onMouseLeave={onLeave}>
        <StyledPinned className="datastore-menu-pin-button" onClick={togglePin}>
          {isDatastoresMenuPinned && <PushpinFilled rotate={-45} />}
          {!isDatastoresMenuPinned && <PushpinOutlined />}
        </StyledPinned>
        {isDatastoresMenuActive &&
          domainsInfo?.data &&
          domainsInfo?.data?.length > 0 && (
            <Tabs
              type={"card"}
              defaultActiveKey={tab}
              items={items}
              onChange={onChange}
              style={{
                position: "absolute",
                marginTop: "50px",
              }}
            />
          )}{" "}
        <div
          className="max-h-[1200px] w-full relative overflow-hidden mt-[75px]"
          style={{ position: "absolute", top: "25px" }}
          onClick={onEnter}>
          {datastore_types?.isLoading && (
            <div className="flex justify-center">
              <LoadingOutlined />
            </div>
          )}

          {domainsInfo?.data?.length === 0 ||
            (!datastore_types?.isLoading && tab === "Datastores" && (
              <>
                <div
                  id="datastore-types"
                  className="h-full pb-[20px] overflow-auto">
                  <div className="top-shadow sticky" />

                  {datastore_types?.res.map((category) => (
                    <DatastoreCategory category={category} key={category[0]} />
                  ))}
                </div>

                <div className="bottom-shadow absolute" />
              </>
            ))}
          {!datastore_types?.isLoading && tab === "Domains" && <DomainsMenu />}
        </div>
        <div>
          <div className="h-[30px]" />
        </div>
      </StyledWrapper>
    </div>
  );
};

export default DatastoresMenu;
